// material
import {alpha, styled} from '@mui/material/styles';
import {Box, Card, Stack, Typography} from '@mui/material';
// utils
import * as React from "react";
import {useState} from "react";
import {getPublicPrice, getPublicPriceFUll} from "../../../services/LogicService";
import * as LogicService from "../../../services/LogicService";

// ----------------------------------------------------------------------


export default function AutoRecordPrice({regim, legalizedSelected, translationCountry, apostilaSelected, userIsForeign, foreignAuto}) {

    let browserData = LogicService.getBrowserData();

    let userOutside = true;
    if (browserData && browserData.country_code === 'RO') {
        userOutside = false;
    }
    let isUrgent = regim === 'urgent';

    let regimPrice = getPublicPrice(userOutside ? 'AUTO_REGIME_STANDARD_OC' : 'AUTO_REGIME_STANDARD');
    if (isUrgent == true) {
        regimPrice = getPublicPrice(userOutside ? 'AUTO_REGIME_URGENT_OC' : 'AUTO_REGIME_URGENT');
    }

    let translationPrice = !translationCountry ? {urgentPrice: 0, price: 0} : getPublicPriceFUll(translationCountry.label)
    if (translationPrice == undefined || translationPrice == null) {
        translationPrice = {urgentPrice: 0, price: 0}
    }
    let finalTranslationPrice = 0;
    let finalApostilaPrice = 0;
    let finalExpertPrice = 0;
    let finalForeignDrivingLicensePrice = 0;
    if (legalizedSelected == true) {
        finalTranslationPrice = isUrgent ? translationPrice.urgentPrice : translationPrice.price;
    }
    if (apostilaSelected == true) {
        finalApostilaPrice = getPublicPrice('AUTO_APOSTILA');
    }
    if (userIsForeign == true) {
        finalExpertPrice = getPublicPrice('AUTO_EXPERT_VERIFICATION');
    }
    if (foreignAuto == true) {
        finalForeignDrivingLicensePrice = getPublicPrice('AUTO_FOREIGN_DRIVING_LICENSE');
    }

    return (
        <Stack direction="column"
               justifyContent="center"
               border={"1px solid rgba(0, 0, 0, 0.15)"}
               padding={"10px"} borderRadius={"10px"}
               sx={{
                   background: "rgba(0, 0, 0, 0.05)"
               }}
        >
            <Typography variant="h6" sx={{display: 'flex', justifyContent: 'flex-end'}}>
                Cost:
                {
                    getPublicPrice('AUTO_DELIVERY_ELECTRONIC')
                    + regimPrice + finalTranslationPrice + finalApostilaPrice + finalExpertPrice + finalForeignDrivingLicensePrice
                } RON
            </Typography>
        </Stack>
    );
}
